import { connect } from 'react-redux';

import { createStore } from '@/features/storeCreatePage/actions';

import NewStore from './component';

const mapDispatchToProps = { createStore };

export default connect(null, mapDispatchToProps)(NewStore);
